import React from "react";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function CreateCard() {
  const navigate = useNavigate();

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => navigate("/strategies")}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") navigate("/strategies");
      }}
      className="bg-slate-50 border border-slate-200 rounded-2xl p-5 flex flex-col items-center justify-center min-h-[300px] cursor-pointer hover:border-blue-300 hover:shadow-md hover:bg-white transition-all group relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(#3b82f6_1px,transparent_1px)] [background-size:16px_16px]" />
      <div className="absolute inset-0 bg-gradient-to-t from-blue-100/40 to-transparent" />

      <div className="relative z-10 flex flex-col items-center">
        <div className="w-16 h-16 mb-4 rounded-full border-2 border-slate-200 flex items-center justify-center group-hover:scale-110 transition-transform bg-slate-50">
          <Plus size={40} className="text-slate-700" />
        </div>
        <h3 className="text-xl font-bold text-slate-900 mb-2">Create strategy</h3>
        <p className="text-slate-500 text-sm">Create your workflow with K-Quant</p>
      </div>
    </div>
  );
}
